import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, IconButton, Button, CircularProgress,
} from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

function IdleView({
  hasExistingTranscript, isGeneratingNote, onStart, onGenerate,
}) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <IconButton
        onClick={onStart}
        aria-label={hasExistingTranscript ? 'Resume recording' : 'Start recording'}
        sx={{
          width: 80,
          height: 80,
          bgcolor: 'primary.main',
          mx: 'auto',
          mb: 2,
          transition: 'all 0.2s',
          '&:hover': {
            transform: 'scale(1.05)',
            bgcolor: 'primary.dark',
          },
        }}
      >
        <MicIcon
          sx={{
            fontSize: 40,
            color: 'white',
          }}
        />
      </IconButton>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {hasExistingTranscript
          ? 'Session saved. Tap to resume.'
          : 'Tap to start session'}
      </Typography>

      {hasExistingTranscript && (
        <Button
          variant="contained"
          startIcon={isGeneratingNote ? <CircularProgress size={18} color="inherit" /> : <AutoAwesomeIcon />}
          onClick={onGenerate}
          disabled={isGeneratingNote}
          fullWidth
          sx={{
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          {isGeneratingNote ? 'Generating...' : 'Generate Note'}
        </Button>
      )}
    </Box>
  );
}

IdleView.propTypes = {
  hasExistingTranscript: PropTypes.bool.isRequired,
  isGeneratingNote: PropTypes.bool.isRequired,
  onStart: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
};

export default IdleView;
